// 单项目订单创建
export default {
    btn_queryByCard: "刷卡",
    btn_allEnter: "全部进场",
    table_title: "项目订单列表",
    tl_index: "序号",
    tl_proj: "项目",
    tl_kartName: "车型",
    tl_space_proj: "场地/项目名称",
    tl_spec_player: "车型/选手",
    tl_price: "价格",
    tl_date: "日期/时间",
    tl_schedule: "场次",
    tl_num: "数量",
    tl_amount: "小计",
    statistical_desc: "张车票 订单合计：",

    // 叫号列表
    tip_enter: "进场检票中：",
    tip_group: "组",
    tip_checked: "(正在检票)",

    // 新增项目
    dl_title: "新增项目",
    dp_space: "请选择场地",
    dl_date: "游戏日期",
    dp_date: "请选择日期",
    dl_projName: "项目名称",
    dp_projName: "请选择项目",
    dl_schedule: "场次",
    dp_schedule: "场次",
    op_code: "场",
    dl_spec: "车型",
    dp_spec: "请选择车型",
    dl_originPrice: "现价",
    dl_price: "原价",
    dl_quantity: "库存",
    dl_number: "数量",
    dp_number: "请输入",
    dl_operator: "操作",
    btn_addItem: "加入订单",

    em_number: "数量不能为空",
    em_quantityWarn: "库存数量不足",
    sm_addItem: "加入成功",
    em_playerInput: "请输入对应数量的参赛选手资料",
    em_nameExist: "参赛选手姓名已存在",
    sm_allConsum: "车票已全部核销",
    em_index: "第",
    em_consumTip: "张车票核销成功，其余失败",
    em_settingTip: "个分组操作成功，其余失败",
    em_quantiy: "余量不足",
    em_enterCardPw: "请输入会员卡密码"
};
